import React from 'react'
import { createRoot } from 'react-dom/client'
import { SWRConfig } from 'swr'

import './i18n'
import { App } from './App'
import { BrowserRouter as Router } from 'react-router-dom'
import { DynamicStyleLoader } from './DynamicStyleLoader'
import { getAssetPrefix } from './getAssetPrefix'
import { swrFetcher } from './swrFetcher'

// SWR v2 removed the built-in default fetcher that v0.5 provided.
// This global config restores the same behaviour.
// swrFetcher is defined in ./swrFetcher so it can be imported by tests.

const rootElement = document.getElementById('root')

if (rootElement) {
  const root = createRoot(rootElement)
  root.render(
    <React.StrictMode>
      <SWRConfig value={{ fetcher: swrFetcher }}>
        <Router>
          <DynamicStyleLoader cssUrl={`${getAssetPrefix()}/assets/styles.css`} />
          <App />
        </Router>
      </SWRConfig>
    </React.StrictMode>,
  )
}
